package ru.playa.sce.dto

enum class ObjectStatus(val displayName: String) {
    DRAFT("Черновик"),
    APPROVED("Утвержден"),
    PUBLISHED("Опубликован"),
    ARCHIVED("Архивирован")
}
